import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import Image from '~components/Image'
import Video from '~components/Video'
import RichText from '~components/RichText'
import { Section, breakpoints } from '~styles/global'

const TextAndMediaBlock = ({ heading, text, image, video, className }) => {

  const { mobile } = breakpoints

  return (
    <Section 
      className={className} 
      css={css`
    `}>
      <div css={css`
        /* text-align: left; */
        grid-column: span 6;
        display: grid;
        grid-template-columns: 1fr;
        align-items: center;
        ${mobile} {
          grid-column: span 12;
          order: 2;
        }
      `}>
        <div css={css`
            margin-bottom: 3rem;
            max-width: 540px;
        `}>
            <h1 className="serif" css={css`
                margin-bottom: 0.7em;
            `}>{heading}</h1>
            <RichText content={text} ></RichText>
        </div>
      </div>
      <div css={css`
          grid-column: span 6;
          ${mobile} {
            grid-column: span 12;
            order: 1;
            margin-bottom: 4rem;
          }
      `}>
        { video ?
          (
            <Video src={video} css={css`
              width: 100%;
              border-radius: var(--standard);
              overflow: hidden;
            `} />
          ):
          (
            <Image asset={image} aspectRatio={0.75} css={css`
              border-radius: var(--standard);
              overflow: hidden;
            `}/>
          )
        }
      </div>
    </Section>
  )
}

TextAndMediaBlock.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.array,
  image: PropTypes.object,
  video: PropTypes.object,
}

TextAndMediaBlock.defaultProps = {
  heading: 'We’re a candle store based in Melbourne.',
  text: [
    {
        "_key": "f9d17a10baa5",
        "_type": "block",
        "children": [
            {
                "_key": "8f25454437bd",
                "_type": "span",
                "marks": [],
                "text": "Sed a libero a ex viverra ultrices at vitae neque. Nulla id neque in mi semper interdum sed nec neque. Nunc placerat ac magna quis hendrerit. Proin accumsan porta quam a mollis."
            }
        ],
        "markDefs": [],
        "style": "normal"
    }
  ],
}

export default TextAndMediaBlock
